module.exports = __webpack_public_path__ + "img/kteCupBg.c9c3fc32.png";